export enum ApplicationColorEnum {
  White = 'WHITE',
  Yellow = 'YELLOW',
}
